<footer class="ararity-footer">
  <div class="container-fluid bg-secondary text-light py-5">
    <div class="col-lg-8 mx-auto py-5">
      <div class="col text-center py-2 mb-2">
        <a href="https://www.ararityservices.com"
          class="btn btn-dark text-white mx-auto d-inline-block rounded-pill text-center px-5" title="Ararity Services">
          Ararity Services
        </a>
      </div>
      <div class="col">
        <p class="text-uppercase text-dark text-center ls-2 fs-7">
          <small>Please also visit our Estate Services site</small>
        </p>
      </div>
    </div>
    <div class="col-12 text-center py-3 d-none">
      <p class="text-uppercase fs-6 m-0">To speak with us call 703.372.1543</p>
    </div>
  </div>

  <div class="container-fluid bg-dark text-white p-0 m-0 position-relative">
    <div class="col-lg-8 offset-1 mx-auto py-2 py-md-4">
      <div class="col text-center">
        <ul class="nav justify-content-center text-uppercase">
          <li class="nav-item me-2"><a href="https://ararityauctions.com/auctions/" class="nav-link link-light">Auctions</a></li>
          <li class="nav-item me-2"><a href="https://ararityauctions.com/about/" class="nav-link link-light">About</a></li>
          <li class="nav-item me-2"><a href="https://ararityauctions.com/contact/" class="nav-link link-light">Contact</a></li>
        </ul>
      </div>
    </div>
    <div class="position-absolute end-0 top-0 h-100">
      <div class="pe-4 h-100 d-flex align-items-center">
        <span class="pe-1">
          <a href="https://www.facebook.com/ararityauctions/" title="https://www.facebook.com/ararityauctions/"
            class="text-white">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-facebook" viewBox="0 0 16 16">
              <path
                d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z">
              </path>
            </svg>
          </a>
        </span>
        <span class="me-1 ps-2">
          <a href="https://www.instagram.com/ararityauctions/" title="https://www.instagram.com/ararityauctions/"
            class="text-white">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-instagram" viewBox="0 0 16 16">
              <path
                d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z">
              </path>
            </svg>
          </a>
        </span>
        <span class="ps-1 d-none">
          <a href="#" title="#" class="text-white">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-twitter" viewBox="0 0 16 16">
              <path
                d="M93.508,26.871c-3.062,1.344-6.326,2.233-9.729,2.666c3.502-2.089,6.172-5.373,7.428-9.331 c-3.264,1.945-6.865,3.32-10.705,4.087c-3.1-3.3-7.514-5.343-12.332-5.343c-9.346,0-16.871,7.586-16.871,16.886 c0,1.339,0.113,2.625,0.391,3.85c-14.035-0.685-26.454-7.411-34.796-17.658c-1.458,2.527-2.311,5.419-2.311,8.533 c0,5.847,3.011,11.029,7.499,14.03c-2.713-0.051-5.374-0.839-7.628-2.079c0,0.052,0,0.118,0,0.185 c0,8.205,5.852,15.019,13.525,16.589c-1.374,0.375-2.872,0.557-4.426,0.557c-1.08,0-2.172-0.062-3.196-0.289 c2.187,6.686,8.394,11.601,15.774,11.76c-5.744,4.493-13.037,7.201-20.931,7.201c-1.385,0-2.713-0.062-4.041-0.232 c7.478,4.823,16.341,7.576,25.898,7.576c31.067,0,48.05-25.734,48.05-48.04c0-0.746-0.025-1.467-0.061-2.182 C88.398,33.258,91.213,30.288,93.508,26.871z">
              </path>
            </svg>
          </a>
        </span>
      </div>
    </div>
  </div>

  <div class="container-fluid bg-black text-white py-5 text-uppercase">
    <div class="col-lg-8 mx-auto py-5">
      <div class="col text-center py-2">
        <a href="/" title="Ararity Auctions" class="mb-5 d-block">
          <img src="https://www.ararityauctions.com/assets/img/brand/logo_full_blk.svg" alt="Ararity Auctions"
            height="40">
        </a>
        <p class="fs-6 pt-3 text-secondary ls-2">
          8210 Cinderbed Road, Suite 300, Lorton, VA 22079<br>
          703.372.1543 /
          <a href="mailto:info@ararityauctions.com" title="Email Us" class="text-decoration-none link-secondary text-reset">
            Email Us
          </a>
        </p>
        <p class="fs-6 text-secondary ls-2">
          © {{currentYear}} Ararity LLC / Site by
          <a href="https://www.ashbydesign.com" title="Ashby Design" class="text-decoration-none link-secondary text-reset">
            Ashby Design
          </a>
        </p>
      </div>
    </div>
  </div>
</footer>
